// extracted by mini-css-extract-plugin
export default {"equilateral":"ShapeWrapper_equilateral__8lhUT","square":"ShapeWrapper_square__wC5-6","inner":"ShapeWrapper_inner__PsXPO","circle":"ShapeWrapper_circle__3Y4-X"};